export const DATE_FORMAT = 'MM/DD/YYYY'
export const APPOINTMENT_TIME_FORMAT = 'hh:mm A'
export const APPOINTMENT_DATE_FORMAT = 'MMMM D, YYYY'
export const APPOINTMENT_DATE_TIME_FORMAT = 'dddd, MMMM D [at] hh:mm A z'
export const CALENDAR_DATE_FORMAT = 'YYYY-MM-DD'
export const BIG_SCREEN_WIDTH = 767
